import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { formatTime, round10, millisecondFix } from '../helpers';

const columns = [
  {
    field: 'id',
    headerName: 'Lap',
    width: 70,
  },
  { field: 'laptimeSeconds', headerName: 'laptime (s)', width: 130 },
  { field: 'laptimeMinuteSeconds', headerName: 'laptime (mm:ss)', width: 130 },
  {
    field: 'diffFromBest',
    headerName: 'delta (s)',
    type: 'number',
    width: 90,
  },
];

function lapTimeGrid(beacon_array) {
  const resultArray = [];
  let bestlap;

  for (let i = 0; i < beacon_array.length - 1; i++) {
    const laptime = beacon_array[i + 1] - beacon_array[i];
    if (!bestlap || laptime < bestlap) bestlap = laptime;
    resultArray.push({
      id: i + 1,
      laptimeSeconds: round10(laptime, -3),
      laptimeMinuteSeconds: formatTime(round10(laptime, -3)),
      diffFromBest: null,
    });
  }
  const finalArray = resultArray.map((res) => ({
    ...res,
    diffFromBest: Math.abs(res.laptimeSeconds - bestlap),
  }));

  return finalArray;
}

export default function EnhancedLapTable({ beacon_array }) {
  if (!beacon_array) return;
  const rows = lapTimeGrid(beacon_array);
  return (
    <div style={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        hideFooterPagination={true}
        // initialState={{
        //   pagination: {
        //     paginationModel: { page: 0, pageSize: 5 },
        //   },
        // }}
        // pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div>
  );
}
